/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DatatypeDe } from '../../models/datatype-de';

export interface GetDatatype$Params {
  orid: number;
}

export function getDatatype(http: HttpClient, rootUrl: string, params: GetDatatype$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<DatatypeDe>>> {
  const rb = new RequestBuilder(rootUrl, getDatatype.PATH, 'get');
  if (params) {
    rb.path('orid', params.orid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<DatatypeDe>>;
    })
  );
}

getDatatype.PATH = '/api/MetaModel/datatype/{orid}';
